import { Helmet } from 'react-helmet-async';
import HeroSection from '../components/HeroSection';
import AboutSection from '../components/AboutSection';
import ContentSection from '../components/ContentSection';
import ServicesSection from '../components/ServicesSection';
import PriceTable from '../components/PriceTable';
import GallerySection from '../components/GallerySection';
import ManagerSection from '../components/ManagerSection';
import WhySection from '../components/WhySection';
import FAQSection from '../components/FAQSection';
import LocationSection from '../components/LocationSection';
import CTASection from '../components/CTASection';

const galleryImages = [
  { src: '/gallery-lounge1.jpg', alt: 'Bunny Boy Massage Sukhumvit Lounge Area' },
  { src: '/gallery-lounge2.jpg', alt: 'Happy Ending Massage Sukhumvit Bar Counter' },
  { src: '/gallery-reception.jpg', alt: 'Bunny Boy Massage Reception Desk Sukhumvit' },
  { src: '/gallery-interior1.jpg', alt: 'Massage Parlor Interior Sukhumvit Bangkok' },
  { src: '/gallery-interior2.jpg', alt: 'Luxury Massage Lounge Sukhumvit' },
  { src: '/gallery-interior3.jpg', alt: 'Bunny Boy Massage Premium Reception' },
  { src: '/gallery-lounge3.jpg', alt: 'VIP Lounge Bar Sukhumvit Massage' },
  { src: '/gallery-lounge4.jpg', alt: 'Private Waiting Area Happy Ending Massage' },
  { src: '/gallery-room2.jpg', alt: 'Happy Ending Massage Room Sukhumvit' },
  { src: '/gallery-room3.jpg', alt: 'Premium Massage Room Bangkok Sukhumvit' },
  { src: '/gallery-shower.jpg', alt: 'Private Shower Room Bunny Boy Massage' },
  { src: '/gallery-room1.jpg', alt: 'VIP Room Bunny Boy Massage Sukhumvit' },
];

const managers = [
  { name: 'Nana', age: 'Age 23 · 165cm', image: '/masseuse-new1.jpg' },
  { name: 'Yuri', age: 'Age 22 · 163cm', image: '/masseuse-new2.jpg' },
  { name: 'Bee', age: 'Age 22 · 162cm', image: '/masseuse-14.jpg' },
  { name: 'Kwan', age: 'Age 23 · 165cm', image: '/masseuse-15.jpg' },
  { name: 'Aom', age: 'Age 21 · 160cm', image: '/masseuse-16.jpg' },
  { name: 'Fah', age: 'Age 22 · 163cm', image: '/masseuse-17.jpg' },
  { name: 'Ploy', age: 'Age 23 · 165cm', image: '/gallery-staff.jpg' },
  { name: 'Nong', age: 'Age 22 · 160cm', image: '/gallery-staff2.jpg' },
  { name: 'Fern', age: 'Age 24 · 163cm', image: '/gallery-staff3.jpg' },
  { name: 'Bam', age: 'Age 21 · 158cm', image: '/gallery-staff4.jpg' },
  { name: 'Mint', age: 'Age 22 · 162cm', image: '/masseuse-5.jpg' },
  { name: 'Pim', age: 'Age 23 · 160cm', image: '/masseuse-6.jpg' },
  { name: 'Nan', age: 'Age 21 · 164cm', image: '/masseuse-7.jpg' },
  { name: 'Som', age: 'Age 24 · 158cm', image: '/masseuse-8.jpg' },
  { name: 'Joy', age: 'Age 22 · 161cm', image: '/masseuse-9.jpg' },
  { name: 'Mew', age: 'Age 23 · 163cm', image: '/masseuse-10.jpg' },
  { name: 'Dao', age: 'Age 21 · 159cm', image: '/masseuse-11.jpg' },
  { name: 'Pear', age: 'Age 22 · 165cm', image: '/masseuse-12.jpg' },
  { name: 'Oil', age: 'Age 23 · 160cm', image: '/masseuse-13.jpg' },
];

const priceData = {
  standard: {
    title: 'Standard Room',
    packages: [
      { duration: '60 minutes', price: '฿2,000', items: ['Aromatherapy Massage', 'Kassai Massage'] },
      { duration: '90 minutes', price: '฿2,500', items: ['Body Scrub', 'Aromatherapy Massage', 'Kassai Massage'] },
      { duration: '120 minutes', price: '฿3,000', items: ['Body Scrub', 'Aromatherapy Massage', 'Kassai Massage'] },
    ],
  },
  luxury: {
    title: 'Luxury Room',
    packages: [
      { duration: '60 minutes', price: '฿2,700', items: ['Spa Hot Tub Onsen', 'Aromatherapy Massage', 'Kassai Massage'] },
      { duration: '90 minutes', price: '฿3,200', items: ['Spa Hot Tub Onsen', 'Body Scrub', 'Aromatherapy Massage', 'Kassai Massage'] },
      { duration: '120 minutes', price: '฿3,700', items: ['Spa Hot Tub Onsen', 'Body Scrub', 'Aromatherapy Massage', 'Kassai Massage'] },
    ],
  },
  extras: {
    title: 'Extra Option',
    items: [
      { name: 'Stocking', price: '฿300' },
      { name: 'Cosplay', price: '฿300' },
      { name: 'Body to Body', price: '฿500' },
    ],
  },
};

const priceDataZh = {
  standard: {
    title: '标准房间',
    packages: [
      { duration: '60 分钟', price: '฿2,000', items: ['芳香精油按摩', '卡赛按摩'] },
      { duration: '90 分钟', price: '฿2,500', items: ['身体磨砂', '芳香精油按摩', '卡赛按摩'] },
      { duration: '120 分钟', price: '฿3,000', items: ['身体磨砂', '芳香精油按摩', '卡赛按摩'] },
    ],
  },
  luxury: {
    title: '豪华房间',
    packages: [
      { duration: '60 分钟', price: '฿2,700', items: ['温泉浴', '芳香精油按摩', '卡赛按摩'] },
      { duration: '90 分钟', price: '฿3,200', items: ['温泉浴', '身体磨砂', '芳香精油按摩', '卡赛按摩'] },
      { duration: '120 分钟', price: '฿3,700', items: ['温泉浴', '身体磨砂', '芳香精油按摩', '卡赛按摩'] },
    ],
  },
  extras: {
    title: '附加选项',
    items: [
      { name: '丝袜 (Stocking)', price: '฿300' },
      { name: '角色扮演 (Cosplay)', price: '฿300' },
      { name: '身体推油 (Body to Body)', price: '฿500' },
    ],
  },
};

const localizedContent = {
  en: {
    faqItems: [
      { q: 'What is a Happy Ending Massage in Sukhumvit?', a: 'A happy ending massage in Sukhumvit is a full-body relaxation massage that concludes with an intimate, sensual finale. At Bunny Boy Massage, our skilled Thai masseuses provide a premium happy ending massage experience in the heart of Sukhumvit, Bangkok. The session begins with a traditional oil massage to relieve tension, followed by a deeply satisfying happy ending tailored to your preferences.' },
      { q: 'Where is Bunny Boy Massage located in Sukhumvit?', a: 'Bunny Boy Massage is located at 3/15, 4th Floor, Sukhumvit 71 Rd, Khwaeng Phra Khanong Nuea, Watthana, Bangkok 10110 — just a 5-minute walk from BTS Phra Khanong station. Our discreet entrance ensures complete privacy. We are open daily from 10:00 AM to 00:00 AM, making us one of the most accessible happy ending massage parlors in Sukhumvit.' },
      { q: 'How much does a Happy Ending Massage cost at Bunny Boy?', a: 'Our happy ending massage in Sukhumvit starts at ฿2,000 for a 60-minute Standard Room session (Aromatherapy Massage + Kassai Massage). The 90-minute Standard Room is ฿2,500 and 120-minute is ฿3,000 (includes Body Scrub). Luxury Room packages with Spa Hot Tub Onsen start at ฿2,700/60 min, ฿3,200/90 min, and ฿3,700/120 min. All prices include private room, shower, and complimentary drinks.' },
      { q: 'Is the Happy Ending Massage at Bunny Boy safe and private?', a: 'Absolutely. Bunny Boy Massage prioritizes complete discretion and safety. Every room is fully private with individual locks. Our staff undergoes regular health screenings. We maintain the highest hygiene standards in all our Sukhumvit massage rooms. Your privacy is guaranteed at our happy ending massage establishment.' },
      { q: 'Do I need to make a reservation for Happy Ending Massage?', a: 'While walk-ins are welcome at our Sukhumvit location, we highly recommend making a reservation to ensure your preferred masseuse is available. You can book via Line (@bunnyboymassage) or call us directly. Advance booking guarantees the best happy ending massage experience without waiting.' },
      { q: 'What types of massage does Bunny Boy offer besides Happy Ending?', a: 'Beyond our signature happy ending massage in Sukhumvit, we offer Aromatherapy Massage, Kassai (Prostate) Massage, Body Scrub, and Spa Hot Tub Onsen (whirlpool bath). Each service can be customized. Our Sukhumvit massage menu caters to every preference and budget.' },
      { q: 'Can I choose my masseuse at Bunny Boy Massage Sukhumvit?', a: 'Yes! At Bunny Boy Massage, you can personally select your masseuse from our lineup of beautiful, professionally trained Thai therapists. Each masseuse specializes in different techniques, from gentle sensual touch to deep tissue happy ending massage. Browse our available staff upon arrival at our Sukhumvit location.' },
      { q: 'What should I expect during my first Happy Ending Massage visit?', a: 'Upon arriving at Bunny Boy Massage in Sukhumvit, you will be greeted at our reception and offered a welcome drink. You can then choose your preferred masseuse and package. After changing into a comfortable robe in your private room, your happy ending massage session begins with a warm shower, followed by the massage of your choice, concluding with a satisfying finale.' },
    ],
    seoContent: [
      {
        title: 'The Ultimate Guide to Happy Ending Massage in Sukhumvit, Bangkok',
        paragraphs: [
          'If you are searching for the best happy ending massage in Sukhumvit, look no further than Bunny Boy Massage. Located on Sukhumvit 71 Rd, Phra Khanong Nuea, Bangkok, we have established ourselves as the premier destination for discerning gentlemen seeking an unforgettable sensual massage experience. Our happy ending massage Sukhumvit services combine expert Thai massage techniques with intimate, personalized attention that goes far beyond ordinary massage parlors.',
          'Sukhumvit is renowned worldwide as Bangkok\'s most exciting entertainment district, and Bunny Boy Massage stands out as the crown jewel of happy ending massage establishments in this area. Whether you are a first-time visitor to Bangkok or a seasoned traveler, our Sukhumvit happy ending massage experience will exceed your expectations in every way.',
          'At Bunny Boy Massage, we understand that a truly exceptional happy ending massage in Sukhumvit requires more than just skilled hands — it demands a complete luxury experience from the moment you walk through our doors. That is why we have invested in creating the most comfortable, stylish, and private massage environment in all of Sukhumvit.',
        ],
        image: '/gallery-interior3.jpg',
        imageAlt: 'Bunny Boy Massage Sukhumvit Premium Interior',
      },
      {
        title: 'Why Bunny Boy is the #1 Happy Ending Massage in Sukhumvit',
        paragraphs: [
          'What sets Bunny Boy Massage apart from other happy ending massage options in Sukhumvit? The answer lies in our uncompromising commitment to quality, privacy, and customer satisfaction. Every aspect of your happy ending massage experience has been carefully designed to provide maximum pleasure and comfort.',
          'Our beautiful Thai masseuses are hand-selected not only for their stunning appearances but also for their exceptional massage skills. Each therapist at our Sukhumvit happy ending massage parlor undergoes extensive training in traditional Thai massage, aromatherapy, and sensual techniques. They are experts at reading your body\'s responses and adjusting their technique to deliver the perfect happy ending massage every time.',
        ],
        list: [
          'Premium location on Sukhumvit 71 Rd — 5 minutes from BTS Phra Khanong',
          'Hand-selected beautiful Thai masseuses with professional training',
          'Luxurious private VIP rooms with individual shower facilities',
          'Complete discretion and privacy guaranteed for every guest',
          'Open daily from 10:00 AM to 00:00 AM for your convenience',
          'Competitive pricing with transparent menu — no hidden charges',
          'Complimentary welcome drinks and premium amenities',
          'Hygiene-certified with regular staff health screenings',
        ],
      },
      {
        title: 'What to Expect at Our Happy Ending Massage Sukhumvit Experience',
        paragraphs: [
          'Your happy ending massage journey at Bunny Boy in Sukhumvit begins the moment you step inside our beautifully designed establishment. Our modern, boutique-style interior features lush green walls, marble countertops, and ambient lighting that immediately puts you at ease. The atmosphere is deliberately crafted to be both sophisticated and sensual — setting the perfect mood for your happy ending massage.',
          'After being warmly greeted at our reception, you will be invited to our comfortable lounge area where you can enjoy a complimentary drink while browsing our selection of available masseuses. At Bunny Boy Massage in Sukhumvit, we believe that choosing the right therapist is essential to the perfect happy ending massage experience, so take your time selecting the girl who appeals to you most.',
          'Once you have made your choice, you will be escorted to your private room — each one individually designed with premium furnishings, mood lighting, and a private bathroom. Your happy ending massage begins with a relaxing warm shower (together if you prefer), followed by a masterful full-body massage using premium aromatic oils. As the session progresses, the intensity builds naturally toward the unforgettable happy ending that has made Bunny Boy the most talked-about massage parlor in Sukhumvit.',
        ],
        image: '/content-image-2.jpg',
        imageAlt: 'Happy Ending Massage Private Room in Sukhumvit',
      },
      {
        title: 'Happy Ending Massage Services & Packages in Sukhumvit',
        titleColor: '#b299fa',
        paragraphs: [
          'Bunny Boy Massage offers a comprehensive menu of happy ending massage services in Sukhumvit to suit every preference and budget. From our Standard Room packages to our Luxury Room with Spa Hot Tub Onsen, every service is designed to provide the ultimate in pleasure and relaxation.',
          'Our Standard Room 60-minute package (฿2,000) is the perfect introduction to the Bunny Boy experience. This signature service includes Aromatherapy Massage and Kassai Massage, culminating in a deeply satisfying happy ending. For those who want more time to enjoy, our Standard Room 90-minute package (฿2,500) adds a luxurious Body Scrub to your Aromatherapy and Kassai Massage session. The 120-minute Standard Room package (฿3,000) offers the most indulgent experience with extended Body Scrub, Aromatherapy Massage, and Kassai Massage.',
          'For the ultimate happy ending massage experience in Sukhumvit, our Luxury Room packages are unmatched. Starting at ฿2,700 for 60 minutes, the Luxury Room includes Spa Hot Tub Onsen (whirlpool bath), Aromatherapy Massage, and Kassai Massage. The 90-minute Luxury Room (฿3,200) and 120-minute Luxury Room (฿3,700) add Body Scrub to the full Spa Hot Tub Onsen experience. It is the definitive way to experience what makes Bunny Boy the best happy ending massage in Sukhumvit.',
        ],
      },
      {
        title: 'Our Facilities: Premium Happy Ending Massage Environment in Sukhumvit',
        paragraphs: [
          'The facilities at Bunny Boy Massage set a new standard for happy ending massage establishments in Sukhumvit. Our space has been designed by professional interior designers to create an atmosphere of luxury, comfort, and discretion.',
          'The main lounge features a stunning green wall with our iconic Bunny Boy logo, comfortable velvet armchairs, and a fully stocked bar. Our bar counter, crafted from rich wood and marble, serves complimentary beverages while you wait for your happy ending massage session. Large-screen TVs and ambient music create a relaxed social atmosphere.',
          'Each of our private massage rooms is equipped with premium massage beds, quality linens, and individual climate control. The private bathrooms include rain showers, premium toiletries, and fresh robes. Every detail has been considered to ensure your happy ending massage in Sukhumvit is a truly five-star experience.',
        ],
        image: '/content-image-3.jpg',
        imageAlt: 'Bunny Boy Massage Luxury Lounge Sukhumvit Bangkok',
      },
      {
        title: 'Location & How to Find Bunny Boy Happy Ending Massage in Sukhumvit',
        titleColor: '#b9a1fc',
        paragraphs: [
          'Finding the best happy ending massage in Sukhumvit is easy when you know where to look. Bunny Boy Massage is strategically located on Sukhumvit 71 Rd, Phra Khanong Nuea, Watthana, Bangkok. We are just a short 5-minute walk from BTS Phra Khanong station, making us incredibly convenient for both tourists and residents.',
          'Our discreet entrance on the 4th floor ensures your privacy while visiting our happy ending massage establishment. If you are coming by taxi, simply tell the driver "Sukhumvit 71, near Phra Khanong BTS" and look for our signage.',
          'We are surrounded by some of Sukhumvit\'s finest hotels, restaurants, and entertainment venues, making Bunny Boy Massage the perfect addition to your evening out in Bangkok. Whether you are staying at a nearby hotel or exploring the Sukhumvit nightlife scene, our happy ending massage is the perfect way to end your night.',
        ],
      },
    ],
    labels: {
      galleryTitle: 'Our Luxurious Facilities',
      gallerySubtitle: 'Step Inside Bunny Boy Massage Sukhumvit',
      priceTitle: 'Happy Ending Massage Sukhumvit Price List',
      priceSubtitle: 'Transparent Pricing — No Hidden Fees',
      managerTitle: 'Meet Our Beautiful Masseuses',
      managerSubtitle: 'Hand-Selected Thai Therapists',
      faqTitle: 'Frequently Asked Questions',
      faqSubtitle: 'Happy Ending Massage Sukhumvit — Your Questions Answered',
      locationTitle: 'Find Us in Sukhumvit',
      locationSubtitle: 'Visit Bunny Boy Massage Today',
      address: '3/15, 4th Floor, Sukhumvit 71 Rd, Khwaeng Phra Khanong Nuea, Watthana, Bangkok 10110',
      hours: 'Open Daily: 10:00 AM - 00:00 AM',
      directions: ['5-minute walk from Bangkok BTS Phra Khanong Station'],
    },
  },
  zh: {
    faqItems: [
      { q: '什么是曼谷情色按摩？Bunny Boy Massage有什么特别之处？', a: '曼谷情色按摩是一种融合了传统泰式按摩技术与亲密感官体验的高端服务。在Bunny Boy Massage，我们将正宗的泰式按摩传统与个性化的亲密关注完美结合，为每位客人提供超越普通按摩店的曼谷情色按摩体验。我们的曼谷情色按摩从温热精油全身按摩开始，逐步升温至令人难忘的感官高潮，每一步都由经过专业培训的按摩师精心引导。' },
      { q: 'Bunny Boy Massage在曼谷什么位置？交通方便吗？', a: 'Bunny Boy Massage位于曼谷素坤逸71路3/15号4楼（Khwaeng Phra Khanong Nuea, Watthana, Bangkok 10110），距BTS Phra Khanong站仅5分钟步行路程。我们是曼谷交通最便利的曼谷情色按摩场所之一。4楼的私密入口确保每位前来体验曼谷情色按摩的客人的完全隐私。每天上午10:00至午夜营业。' },
      { q: '曼谷情色按摩在Bunny Boy Massage多少钱？', a: '我们的曼谷情色按摩价格：标准房间60分钟฿2,000（芳香精油按摩+卡赛按摩），90分钟฿2,500，120分钟฿3,000（含身体磨砂）。豪华房间含温泉浴60分钟฿2,700，90分钟฿3,200，120分钟฿3,700。所有曼谷情色按摩套餐均包含私人房间、淋浴和免费饮品。价格透明，无任何隐藏费用。' },
      { q: '在Bunny Boy Massage体验曼谷情色按摩安全吗？隐私有保障吗？', a: '绝对安全。Bunny Boy Massage将客人隐私和安全放在首位。每间曼谷情色按摩房间完全私密，配有独立门锁。我们的按摩师定期接受健康检查。所有房间在每次服务后都会彻底消毒清洁。4楼的隐蔽入口进一步确保了您体验曼谷情色按摩时的完全隐私。我们维持着曼谷最高的卫生标准。' },
      { q: '体验曼谷情色按摩需要提前预约吗？', a: '虽然我们接受直接到店，但强烈建议通过LINE (ID: bunnyboybkk)、WhatsApp (ID: bunnyboybkk) 或致电081-110-3766提前预约您的曼谷情色按摩体验。提前预约可确保您喜欢的按摩师在场，并享受无需等待的最佳曼谷情色按摩体验。高峰时段（晚上7-11点）特别建议预约。' },
      { q: 'Bunny Boy Massage除了曼谷情色按摩还提供哪些服务？', a: '除了我们招牌的曼谷情色按摩服务，我们还提供芳香精油按摩、卡赛按摩（前列腺按摩）、身体磨砂和温泉浴（Spa Hot Tub Onsen）。每项服务都可根据您的喜好定制。Bunny Boy Massage是曼谷素坤逸最全面的情色按摩服务提供商。' },
      { q: '在Bunny Boy Massage可以自己选择按摩师吗？', a: '当然可以！在Bunny Boy Massage，您可以从我们精心挑选的美丽泰国按摩师阵容中亲自选择。每位按摩师都经过专业的曼谷情色按摩技术培训，擅长不同风格——从温柔的感官抚触到深层组织按摩。我们的曼谷情色按摩师以20代年轻美丽的女性为主，到店后可直接浏览选择。' },
      { q: '第一次体验曼谷情色按摩应该注意什么？', a: '到达Bunny Boy Massage后，接待人员会热情欢迎您并提供迎宾饮品。然后您可以选择喜欢的按摩师和曼谷情色按摩套餐。在私人房间换好浴袍后，您的曼谷情色按摩之旅从温暖的淋浴开始，然后是精心的全身按摩，最后以令人满足的高潮体验结束。放松心态、享受过程是获得最佳曼谷情色按摩体验的关键。' },
    ],
    seoContent: [
      {
        title: '曼谷情色按摩终极指南 — 素坤逸最佳感官体验',
        paragraphs: [
          '如果您正在寻找最好的曼谷情色按摩体验，Bunny Boy Massage是您的不二之选。位于曼谷素坤逸71路Phra Khanong Nuea，我们已成为追求难忘感官按摩体验的绅士们的首选目的地。我们的曼谷情色按摩服务将精湛的泰式按摩技术与亲密的个性化关注完美结合，远远超越普通按摩店所能提供的体验。无论您是商务旅客还是度假游客，Bunny Boy Massage都能为您提供曼谷最顶级的情色按摩享受。每一次曼谷情色按摩都是一次感官的升华之旅，让您在繁忙的旅途中找到真正的放松与快乐。',
          '素坤逸（Sukhumvit）作为曼谷最令人兴奋的娱乐区而享誉全球，而Bunny Boy Massage在众多曼谷情色按摩场所中脱颖而出，被誉为该区域的"皇冠明珠"。无论您是首次到访曼谷还是经验丰富的旅行者，我们的曼谷情色按摩体验都将以各种方式超越您的期待。从精心设计的室内环境到训练有素的按摩师团队，每一个细节都彰显着我们对曼谷情色按摩品质的极致追求。我们的曼谷情色按摩不仅仅是一次身体上的放松，更是一次完整的感官享受——视觉上的精美环境、嗅觉上的高级精油、触觉上的专业按摩师，以及听觉上的轻柔音乐，所有元素完美融合。',
          '在Bunny Boy Massage，我们深知一次真正卓越的曼谷情色按摩需要的不仅是娴熟的双手——它需要从您踏进大门那一刻起的完整奢华体验。这就是为什么我们投入大量资源，在素坤逸打造出最舒适、最时尚、最私密的曼谷情色按摩环境。从意大利进口大理石台面到定制氛围灯光，从顶级芳香精油到柔软舒适的浴袍，每一个细节都经过精心考量，只为确保您的曼谷情色按摩之旅完美无瑕。我们的回头客率高达85%，这是对我们曼谷情色按摩服务品质的最好证明。许多客人甚至在离开曼谷前的最后一晚，也要再来一次Bunny Boy Massage，带走这座城市最美好的记忆。',
        ],
        image: '/gallery-interior3.jpg',
        imageAlt: 'Bunny Boy Massage 曼谷情色按摩 素坤逸高级内部环境',
      },
      {
        title: '为什么Bunny Boy Massage是曼谷情色按摩的No.1选择',
        paragraphs: [
          '是什么让Bunny Boy Massage在众多曼谷情色按摩选项中脱颖而出？答案在于我们对品质、隐私和客户满意度的不妥协承诺。曼谷情色按摩体验的每一个方面都经过精心设计，旨在提供最大程度的快感和舒适度。从您进入我们位于素坤逸的豪华场所那一刻起，您就会感受到与众不同——优雅的绿色主题墙、精致的木质和大理石吧台、柔和的灯光氛围，一切都在无声地告诉您：这里是曼谷情色按摩的最高殿堂。我们的每一个设计决策都围绕着一个核心理念：为客人创造最完美的曼谷情色按摩环境。',
          '我们的美丽泰国按摩师不仅因其出众的外貌而被精心挑选，更因其卓越的按摩技能而脱颖而出。在Bunny Boy Massage，每位曼谷情色按摩师都接受过传统泰式按摩、芳香疗法和感官按摩技术的全面培训。她们是解读您身体反应并调整技巧的专家，确保每次都能提供完美的曼谷情色按摩体验。我们的按摩师以20代年轻女性为主，拥有曼谷最大规模的美丽按摩师阵容，每位都通过了严格的曼谷情色按摩技能考核。这种对人才的严格筛选确保了每一位走进Bunny Boy的客人都能享受到曼谷最高水准的情色按摩服务。',
        ],
        list: [
          '黄金位置：素坤逸71路 — 距BTS Phra Khanong站仅5分钟步行',
          '精心挑选的美丽泰国按摩师，接受专业曼谷情色按摩培训',
          '豪华私密VIP房间，配备独立淋浴设施',
          '为每位曼谷情色按摩客人保证完全的隐私和安全',
          '每天上午10:00至午夜营业，方便您随时体验曼谷情色按摩',
          '透明价格体系 — 无任何隐藏费用',
          '免费迎宾饮品和高级洗浴用品',
          '定期健康检查认证，维持最高卫生标准',
        ],
      },
      {
        title: '曼谷情色按摩完整体验流程 — 从到达到享受',
        paragraphs: [
          '您在Bunny Boy Massage的曼谷情色按摩之旅从踏入我们精心设计的场所那一刻就开始了。我们现代精品风格的室内设计以绿意盎然的植物墙、大理石台面和温暖的氛围灯光为特色，让您立刻放松下来。氛围被刻意打造得既高雅又性感——为您的曼谷情色按摩体验设定完美基调。柔和的背景音乐和淡雅的香薰气息弥漫在空气中，营造出一种远离都市喧嚣的静谧感，让您在开始曼谷情色按摩之前就已经感受到深层的放松。',
          '在接待处受到热情欢迎后，您将被邀请至我们舒适的休息区，在那里可以享用免费饮品（提供多种饮料选择），同时浏览我们可用的按摩师阵容。在Bunny Boy Massage，我们相信选择合适的按摩师对于完美的曼谷情色按摩体验至关重要，所以请花时间挑选最吸引您的那位。我们的按摩师阵容是曼谷情色按摩行业中最大的之一，每一位都经过严格的曼谷情色按摩技术培训和专业考核。您也可以向我们的接待人员咨询推荐，他们会根据您的偏好为您匹配最适合的曼谷情色按摩师。',
          '做出选择后，您将被带到私人房间——每间房间都经过独立设计，配备高级家具、氛围灯光和私人浴室。您的曼谷情色按摩从温暖的共浴开始（如果您愿意的话），随后是使用高级芳香精油的精湛全身按摩。按摩师的双手在您身体上流畅地游走，从肩颈到腰背，从手臂到腿部，每一个部位都得到专业而温柔的照顾。随着体验的深入，感官强度自然升温，最终达到让Bunny Boy成为素坤逸最受关注的曼谷情色按摩场所的那个令人难忘的高潮时刻。整个过程流畅自然，节奏由您掌控，没有任何急促或尴尬，只有纯粹的放松和快感。这就是为什么来过一次的客人总会再来——因为曼谷情色按摩的最高标准，就在这里。',
        ],
        image: '/content-image-2.jpg',
        imageAlt: '曼谷情色按摩私人房间 素坤逸',
      },
      {
        title: '曼谷情色按摩服务套餐与价格 — 满足每种需求',
        titleColor: '#b299fa',
        paragraphs: [
          'Bunny Boy Massage提供全面的曼谷情色按摩服务菜单，满足每种偏好和预算。从标准房间套餐到含温泉浴的豪华房间套餐，每项服务都旨在提供极致的快感和放松体验。我们的曼谷情色按摩价格透明合理，在素坤逸地区具有很高的性价比。所有曼谷情色按摩套餐均包含私人房间、淋浴设施和免费迎宾饮品，无任何隐藏费用或额外收费。',
          '标准房间60分钟套餐（฿2,000）是体验Bunny Boy的完美入门，包含芳香精油按摩和卡赛按摩。90分钟套餐（฿2,500）增加身体磨砂服务，是我们最受欢迎的套餐。120分钟套餐（฿3,000）提供最充裕的时间，享受身体磨砂、芳香精油按摩和卡赛按摩的完整体验。这是体验曼谷情色按摩精髓的最佳选择。',
          '如果您追求素坤逸最顶级的曼谷情色按摩体验，豪华房间套餐无与伦比。60分钟฿2,700起，包含温泉浴（Spa Hot Tub Onsen）、芳香精油按摩和卡赛按摩。90分钟豪华套餐（฿3,200）和120分钟豪华套餐（฿3,700）还增加身体磨砂服务，是体验Bunny Boy为何成为素坤逸最佳曼谷情色按摩场所的终极方式。无论您选择哪种曼谷情色按摩套餐，我们都确保提供超越价格的体验价值。',
        ],
      },
      {
        title: '曼谷情色按摩环境设施 — 素坤逸最豪华的按摩体验',
        paragraphs: [
          'Bunny Boy Massage的设施为曼谷情色按摩场所树立了全新标杆。我们的空间由专业室内设计师精心打造，营造出奢华、舒适和隐私兼备的氛围。每一个角落都透露着对曼谷情色按摩体验品质的极致追求。从入口处的低调优雅到内部的精致奢华，每一个空间转换都经过精心规划，确保您在Bunny Boy Massage享受的曼谷情色按摩体验与众不同。',
          '主休息厅以令人惊叹的绿色植物墙和我们标志性的Bunny Boy商标为特色，配备舒适的天鹅绒扶手椅和储备齐全的酒吧。精选木材和大理石打造的吧台在您等待曼谷情色按摩体验时提供免费饮品服务——从精酿啤酒到软饮料，应有尽有。大屏幕电视和精心挑选的环境音乐创造出轻松惬意的社交氛围，让您在开始曼谷情色按摩之前就已经完全沉浸在愉悦的氛围中。许多客人喜欢在开始他们的曼谷情色按摩前在此小坐片刻，享受这份难得的放松时光。',
          '每间私人曼谷情色按摩房间都配备高级按摩床、优质床单和独立温控系统，确保您在最舒适的环境中享受服务。私人浴室配有雨淋花洒、高级洗浴用品和全新浴袍，让您的曼谷情色按摩前后都能享受五星级的沐浴体验。每一个细节都经过精心考虑：柔和的灯光可以根据您的喜好调节，精选的背景音乐营造出完美的放松氛围。房间在每次使用后都经过彻底消毒，使用的精油和毛巾全部为一次性或经过高温消毒处理，确保您体验曼谷情色按摩时的绝对卫生安全。我们对环境品质的追求，是让Bunny Boy Massage成为曼谷情色按摩领域标杆的重要原因。',
        ],
        image: '/content-image-3.jpg',
        imageAlt: 'Bunny Boy Massage 曼谷情色按摩 豪华休息厅 素坤逸',
      },
      {
        title: '如何找到曼谷情色按摩首选地 — Bunny Boy Massage位置指南',
        titleColor: '#b9a1fc',
        paragraphs: [
          '寻找曼谷最好的情色按摩很简单——Bunny Boy Massage战略性地位于曼谷素坤逸71路Phra Khanong Nuea, Watthana区。距BTS Phra Khanong站仅5分钟步行路程，我们是曼谷交通最便利的曼谷情色按摩场所之一，无论是初次来曼谷的游客还是长期居住的外籍人士都可以轻松找到我们。从BTS站出口2出来，沿素坤逸71路步行约5分钟即可到达——即使是第一次来也不会迷路。',
          '我们位于4楼的隐蔽入口确保了您在体验曼谷情色按摩时的完全隐私和安全。如果乘坐出租车或Grab前来，只需告诉司机"素坤逸71路，Phra Khanong BTS附近"即可轻松到达。周围设有多个公共和私人停车场，自驾前来体验我们的曼谷情色按摩也完全没有问题。我们的4楼位置不仅提供了极佳的隐私保护，还确保了安静舒适的曼谷情色按摩环境——远离街道的喧嚣，让您在完全宁静的空间中享受感官之旅。',
          '我们周围环绕着素坤逸最好的酒店（如万豪、诺富特等国际连锁品牌）、高级餐厅和时尚娱乐场所，使Bunny Boy Massage成为您曼谷之夜的完美收尾选择。无论您是住在附近的酒店还是在探索素坤逸的精彩夜生活，我们的曼谷情色按摩都是为美好夜晚画上完美句号的最佳方式。素坤逸71路的地理位置优越，BTS、出租车、Grab、摩的都可以轻松到达，让您无需为交通问题烦心，全身心投入到曼谷最优质的情色按摩体验中。欢迎通过LINE（ID: bunnyboybkk）或WhatsApp（ID: bunnyboybkk）提前预约，确保您到达时即可享受无等待的曼谷情色按摩服务。',
        ],
      },
    ],
    labels: {
      galleryTitle: '我们的豪华设施',
      gallerySubtitle: '走进 Bunny Boy Massage 曼谷情色按摩',
      priceTitle: '曼谷情色按摩价格表',
      priceSubtitle: '透明定价 — 无任何隐藏费用',
      managerTitle: '认识我们的美丽按摩师',
      managerSubtitle: '精心挑选的泰国按摩师',
      faqTitle: '常见问题',
      faqSubtitle: '曼谷情色按摩 — 您的疑问一一解答',
      locationTitle: '如何到达我们',
      locationSubtitle: '立即体验 Bunny Boy Massage 曼谷情色按摩',
      address: '3/15, 4楼, 素坤逸71路, Khwaeng Phra Khanong Nuea, Watthana, 曼谷 10110',
      hours: '每日营业: 上午10:00 - 午夜00:00',
      directions: ['距曼谷BTS Phra Khanong站步行5分钟'],
    },
  },
  ko: {
    faqItems: [
      { q: '방콕 변마란 정확히 무엇인가요?', a: '방콕 변마는 전신 릴렉싱 마사지 후 친밀하고 감각적인 피날레로 마무리되는 프리미엄 마사지 서비스입니다. "변마"는 "변태 마사지"의 줄임말로, 일반 태국 마사지를 넘어서는 특별한 감각 체험을 의미합니다. Bunny Boy Massage에서는 엄선된 20대 전문 태국 마사지사가 방콕 수쿰빗 중심부에서 최고급 방콕 변마 서비스를 제공합니다. 전통 태국 마사지 기법과 감각적 터치를 결합한 Bunny Boy Massage의 방콕 변마는 다른 어떤 곳에서도 경험할 수 없는 독보적인 만족감을 선사합니다.' },
      { q: '방콕 변마 가격은 얼마인가요?', a: 'Bunny Boy Massage의 방콕 변마 가격: 스탠다드 룸 60분 ฿2,000(아로마테라피 마사지 + 카사이 마사지), 90분 ฿2,500, 120분 ฿3,000(바디스크럽 포함). 럭셔리 룸(스파 핫터브 온천욕 포함) 60분 ฿2,700, 90분 ฿3,200, 120분 ฿3,700. 모든 방콕 변마 가격에 프라이빗 룸, 샤워, 무료 웰컴 음료가 포함되며, 숨겨진 추가 비용은 일절 없습니다. 바트/한화/달러 결제 가능합니다.' },
      { q: 'Bunny Boy Massage의 방콕 변마는 어디에 있나요?', a: 'Bunny Boy Massage는 방콕 수쿰빗 71 로드 3/15, 4층에 위치하며, BTS 프라카농역에서 도보 단 5분 거리입니다. 4층의 프라이빗한 입구로 방콕 변마를 찾는 모든 고객의 완벽한 프라이버시를 보장합니다. 택시나 Grab 이용 시 "수쿰빗 71, 프라카농 BTS 근처"라고 말씀하시면 됩니다. 매일 오전 10시부터 자정까지 영업합니다.' },
      { q: '방콕 변마 안전하고 프라이버시가 보장되나요?', a: '네, Bunny Boy Massage의 방콕 변마는 절대적으로 안전합니다. 모든 방콕 변마 룸은 완전히 프라이빗하며 개별 잠금장치가 설치되어 있습니다. 마사지사는 정기적으로 건강 검진을 받으며, 모든 룸은 매 서비스 후 철저히 소독됩니다. 4층의 별도 입구가 방콕 변마 고객의 완벽한 프라이버시를 보장합니다. 타올과 시트는 1회용 또는 고온 소독 처리됩니다.' },
      { q: '방콕 변마 예약은 어떻게 하나요?', a: '방콕 변마 예약은 LINE (ID: bunnyboybkk), WhatsApp (ID: bunnyboybkk), 또는 전화 081-110-3766로 가능합니다. 사전 예약을 강력히 권장합니다. 방콕 변마는 Bunny Boy Massage의 가장 인기 있는 서비스이므로, 특히 저녁 피크 시간대(오후 7시~11시)에는 사전 예약이 필수입니다. LINE이나 WhatsApp으로 방콕 변마를 예약하시면 사전에 마사지사 라인업을 확인하실 수 있습니다.' },
      { q: '방콕 변마에서 마사지사를 직접 선택할 수 있나요?', a: '물론입니다! Bunny Boy Massage에서는 방콕 변마 고객이 직접 마사지사를 선택할 수 있습니다. 도착하시면 우리의 엄선된 20대 아름다운 태국 마사지사 라인업을 직접 보시고, 가장 마음에 드는 분을 선택하실 수 있습니다. 모든 방콕 변마 마사지사는 전통 태국 마사지, 아로마테라피, 감각 마사지 기법에 대한 전문 교육을 이수했습니다.' },
      { q: '처음 방콕 변마를 체험할 때 어떤 준비가 필요한가요?', a: '특별한 준비는 필요 없습니다. Bunny Boy Massage에 도착하시면 리셉션에서 따뜻하게 맞이하고 무료 웰컴 음료를 제공합니다. 방콕 변마 마사지사와 원하시는 코스를 선택한 후, 프라이빗 룸에서 편안한 가운으로 갈아입고 따뜻한 샤워를 먼저 합니다. 그 다음 본격적인 방콕 변마 마사지가 진행되며, 만족스러운 피날레로 마무리됩니다. 첫 방문이시라면 90분 프리미엄 코스를 추천합니다.' },
      { q: '방콕 변마 외에 어떤 서비스가 있나요?', a: 'Bunny Boy Massage는 방콕 변마 외에도 아로마테라피 마사지, 카사이(전립선) 마사지, 바디스크럽, 스파 핫터브 온천욕(월풀 바스) 등 다양한 서비스를 제공합니다. 각 서비스는 고객의 취향에 맞게 맞춤형으로 조정 가능합니다. 방콕 변마와 함께 다른 서비스도 조합하여 나만의 특별한 코스를 만들 수도 있습니다.' },
      { q: '방콕 변마 영업 시간은 어떻게 되나요?', a: 'Bunny Boy Massage는 매일 오전 10:00부터 자정(00:00)까지 영업하며, 주말과 공휴일 포함 연중무휴입니다. 방콕 변마는 오후와 저녁 시간대가 가장 인기 있으므로, 피크 타임에는 사전 예약을 권장합니다. 점심 시간대에 방콕 변마를 예약하시면 비교적 여유롭게 서비스를 받으실 수 있습니다.' },
    ],
    seoContent: [
      {
        title: '방콕 변마 완벽 가이드 — 수쿰빗 최고의 프리미엄 변마 체험',
        paragraphs: [
          '방콕 변마를 찾고 계시다면, Bunny Boy Massage가 바로 정답입니다. 방콕 수쿰빗 71 로드에 위치한 Bunny Boy Massage는 방콕 변마를 원하는 한국인 고객에게 가장 신뢰받는 최고의 목적지입니다. "변마"란 일반적인 태국 마사지를 넘어서, 전신 릴렉싱 마사지와 감각적인 피날레가 결합된 특별한 프리미엄 체험을 의미합니다.',
          '수쿰빗은 방콕에서 가장 활기찬 엔터테인먼트 지구로, 전 세계 관광객과 비즈니스 여행객이 모이는 곳입니다. 이 수쿰빗의 한복판에서 Bunny Boy Massage는 방콕 변마의 최고봉으로 자리잡고 있습니다. BTS 프라카농역에서 도보 5분이라는 탁월한 접근성과, 4층의 프라이빗한 입구로 완벽한 프라이버시를 보장하며, 방콕 변마를 찾는 고객들에게 안심하고 방문할 수 있는 환경을 제공합니다.',
          'Bunny Boy Massage의 방콕 변마가 다른 곳과 차별화되는 핵심은 바로 "사람"입니다. 우리의 방콕 변마 마사지사는 외모와 기술력을 모두 겸비한 20대 엄선 태국 여성들로, 전통 태국 마사지부터 아로마테라피, 감각 마사지까지 체계적인 전문 교육을 이수했습니다. 도착 순간부터 떠나는 순간까지, 방콕 변마의 모든 과정이 고객의 최대 만족을 위해 설계되어 있습니다.',
          '방콕 변마를 처음 경험하시는 분이든, 이미 여러 곳을 경험해보신 분이든, Bunny Boy Massage의 방콕 변마는 기존의 기대를 뛰어넘는 새로운 차원의 감각 체험을 약속합니다. 럭셔리한 인테리어, 프리미엄 아로마 오일, 개인 맞춤형 서비스가 결합된 방콕 변마의 정수를 경험해보세요.',
        ],
        image: '/gallery-interior3.jpg',
        imageAlt: '방콕 변마 Bunny Boy Massage 수쿰빗 프리미엄 인테리어',
      },
      {
        title: '방콕 변마 No.1 — Bunny Boy Massage가 최고인 이유',
        paragraphs: [
          '수많은 방콕 변마 업소 중에서 Bunny Boy Massage가 한국인 고객에게 압도적 1위로 추천받는 이유는 분명합니다. 품질, 프라이버시, 고객 만족에 대한 타협 없는 헌신이 우리 방콕 변마를 차별화합니다. 방콕 변마 경험의 모든 측면 — 마사지사의 기술력, 시설의 청결도, 서비스의 세심함 — 이 최대한의 만족과 편안함을 제공하도록 설계되었습니다.',
          '우리의 방콕 변마 마사지사들은 외모뿐만 아니라 뛰어난 마사지 기술로 엄선되었습니다. 각 마사지사는 전통 태국 마사지, 아로마테라피, 딥티슈, 감각적 터치 기법에 대한 최소 150시간 이상의 전문 교육을 이수했습니다. 이러한 체계적인 교육 시스템이 Bunny Boy Massage의 방콕 변마를 수쿰빗 최고 수준으로 유지하는 핵심입니다.',
          '방콕 변마 시장에서 저렴한 가격만을 내세우는 곳은 많지만, 진정한 프리미엄 품질과 고객 안전을 보장하는 곳은 드뭅니다. Bunny Boy Massage는 방콕 변마의 모든 과정에서 최고급 제품만을 사용하고, 매 서비스 후 철저한 소독을 실시하며, 마사지사의 정기적인 건강검진을 의무화하고 있습니다.',
        ],
        list: [
          '수쿰빗 71 로드 프리미엄 위치 — BTS 프라카농역 도보 5분, 방콕 변마 최고의 접근성',
          '20대 엄선 태국 마사지사 — 외모와 기술력을 겸비한 방콕 변마 전문가',
          '완벽한 프라이빗 VIP 룸 — 개별 잠금장치 + 레인 샤워 시설',
          '4층 별도 입구 — 방콕 변마 고객의 완벽한 프라이버시 보장',
          '매일 오전 10시~자정 연중무휴 — 방콕 변마를 원할 때 언제든',
          '투명한 가격 정책 — 숨겨진 비용 없음, 바트/한화/달러 결제',
          '무료 웰컴 드링크 + 프리미엄 어메니티 — 방콕 변마 고객 전용',
          '정기 건강검진 + 매 서비스 후 철저한 소독 — 최고 위생 기준',
        ],
      },
      {
        title: '방콕 변마 체험 과정 — 도착부터 완벽한 만족까지',
        paragraphs: [
          'Bunny Boy Massage의 방콕 변마는 문을 열고 들어서는 순간부터 시작됩니다. 아름답게 디자인된 리셉션 공간 — 녹색 식물벽, 대리석 카운터, 무드 조명 — 이 일상의 스트레스를 즉시 잊게 만들고, 방콕 변마의 세계로 부드럽게 안내합니다.',
          '리셉션에서 따뜻한 환영을 받은 후, 라운지에서 무료 웰컴 음료를 즐기시며 방콕 변마 마사지사 라인업을 직접 확인하고 선택하실 수 있습니다. 부담 없이 마음에 드는 분을 선택하시면 됩니다.',
          '마사지사 선택 후 프라이빗 룸으로 안내됩니다. 편안한 가운으로 갈아입고 따뜻한 레인 샤워를 먼저 즐기신 후, 본격적인 방콕 변마 마사지가 시작됩니다. 프리미엄 아로마 오일을 사용한 전신 마사지로 깊은 이완을 경험한 다음, 방콕 변마의 하이라이트인 감각적인 피날레로 잊을 수 없는 만족감을 선사합니다.',
          '방콕 변마 세션이 끝난 후에도 서비스는 계속됩니다. 따뜻한 샤워와 깨끗한 타올, 그리고 음료와 함께 편안하게 여운을 즐기실 수 있습니다. Bunny Boy Massage의 방콕 변마는 단순한 마사지가 아닌, 시작부터 끝까지 완벽하게 설계된 프리미엄 감각 체험입니다.',
        ],
        image: '/content-image-2.jpg',
        imageAlt: '방콕 변마 프라이빗 룸 Bunny Boy Massage 수쿰빗',
      },
      {
        title: '방콕 변마 서비스 & 패키지 — 나에게 맞는 코스 선택',
        titleColor: '#b299fa',
        paragraphs: [
          'Bunny Boy Massage는 다양한 방콕 변마 코스를 제공합니다. 스탠다드 룸 60분(฿2,000)은 아로마테라피 마사지와 카사이 마사지가 포함된 기본 코스입니다. 스탠다드 룸 90분(฿2,500)은 바디스크럽이 추가되어 가장 인기 있는 코스입니다. 스탠다드 룸 120분(฿3,000)은 여유로운 시간으로 바디스크럽, 아로마테라피 마사지, 카사이 마사지를 깊이 있게 즐기실 수 있습니다.',
          '럭셔리 룸은 스파 핫터브 온천욕(월풀 바스)이 포함된 프리미엄 코스입니다. 60분 ฿2,700, 90분 ฿3,200, 120분 ฿3,700으로, 온천욕과 함께 아로마테라피 마사지, 카사이 마사지, 바디스크럽(90분 이상)을 모두 즐기실 수 있습니다.',
          '처음 방콕 변마를 경험하시는 분에게는 90분 프리미엄 코스를 추천합니다. 충분한 시간으로 전신 릴렉싱과 감각 체험을 모두 깊이 있게 즐기실 수 있습니다. 모든 방콕 변마 코스는 고객의 취향에 맞게 커스터마이징 가능하며, 마사지 강도와 스타일을 자유롭게 요청하실 수 있습니다.',
        ],
      },
      {
        title: '방콕 변마 최고급 시설 — 수쿰빗 최고의 프리미엄 환경',
        paragraphs: [
          'Bunny Boy Massage의 방콕 변마 시설은 전문 인테리어 디자이너가 설계한 럭셔리, 편안함, 프라이버시의 완벽한 조화입니다. 방콕 변마를 위한 모든 공간이 고객의 최대 만족을 위해 세심하게 디자인되었습니다.',
          '메인 라운지: 그린월, 벨벳 암체어, 풀바를 갖추고 있으며, 방콕 변마 대기 중 무료 음료를 즐기실 수 있습니다. 라운지 자체만으로도 럭셔리한 분위기를 경험하실 수 있습니다.',
          '프라이빗 방콕 변마 룸: 프리미엄 마사지 베드, 개별 온도조절 시스템, 레인 샤워, 고급 세면도구를 완비하고 있습니다. 각 방콕 변마 룸은 완전한 방음 처리가 되어 있어 외부 소음 걱정 없이 방콕 변마에 집중하실 수 있습니다.',
        ],
        image: '/content-image-3.jpg',
        imageAlt: '방콕 변마 Bunny Boy Massage 럭셔리 라운지 수쿰빗',
      },
      {
        title: '방콕 변마 오시는 길 — Bunny Boy Massage 위치 안내',
        titleColor: '#b9a1fc',
        paragraphs: [
          '방콕 변마를 찾아 Bunny Boy Massage로 오시는 길은 매우 간단합니다. 수쿰빗 71 로드 3/15, 4층에 위치하며, BTS 프라카농역에서 도보 단 5분 거리입니다. 택시나 Grab 이용 시 "수쿰빗 71, 프라카농 BTS 근처"라고 말씀하시면 됩니다.',
          '4층의 별도 프라이빗 입구로 방콕 변마 고객의 완벽한 프라이버시를 보장합니다. 건물 입구에서 엘리베이터를 타고 4층으로 올라오시면 Bunny Boy Massage의 방콕 변마 세계가 펼쳐집니다.',
          '주변에 수쿰빗 최고의 호텔, 한식당, 일식당, 쇼핑몰이 밀집해 있어, 방콕 변마 체험 전후로 식사나 쇼핑을 즐기기에도 최적의 위치입니다. "방콕 변마", "수쿰빗 변마", "방콕 마사지" 등을 검색하시는 분이라면, Bunny Boy Massage가 바로 최고의 선택입니다.',
        ],
      },
    ],
    labels: {
      galleryTitle: '방콕 변마 럭셔리 시설',
      gallerySubtitle: 'Bunny Boy Massage 방콕 변마 내부',
      priceTitle: '방콕 변마 가격표',
      priceSubtitle: '투명한 가격 — 숨겨진 비용 없음',
      managerTitle: '방콕 변마 마사지사 소개',
      managerSubtitle: '엄선된 20대 전문 태국 마사지사',
      faqTitle: '방콕 변마 자주 묻는 질문',
      faqSubtitle: '방콕 변마 — 궁금한 모든 것',
      locationTitle: '방콕 변마 오시는 길',
      locationSubtitle: '지금 Bunny Boy Massage 방콕 변마를 방문하세요',
      address: '3/15, 4층, 수쿰빗 71 로드, Khwaeng Phra Khanong Nuea, Watthana, 방콕 10110',
      hours: '매일 영업: 오전 10:00 - 자정 00:00',
      directions: ['방콕 BTS 프라카농역 도보 5분 — 방콕 변마 최고의 접근성'],
    },
  },
};

function HomePage({ t, lang }) {
  const langAttr = lang === 'zh' ? 'zh-CN' : lang === 'ko' ? 'ko' : 'en';
  const prefix = lang === 'en' ? '' : `/${lang}`;
  const content = localizedContent[lang] || localizedContent.en;
  const { faqItems, seoContent, labels } = content;

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqItems.map(item => ({
      '@type': 'Question',
      name: item.q,
      acceptedAnswer: { '@type': 'Answer', text: item.a },
    })),
  };

  const localBusinessSchema = {
    '@context': 'https://schema.org',
    '@type': 'HealthAndBeautyBusiness',
    name: 'Bunny Boy Massage',
    description: 'Premium happy ending massage in Sukhumvit, Bangkok. Offering Aromatherapy Massage, Kassai Massage, Body Scrub, and Spa Hot Tub Onsen with beautiful Thai masseuses.',
    url: 'https://www.bunnyboymassage.com',
    telephone: '+66811103766',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '3/15, 4th Floor, Sukhumvit 71 Rd',
      addressLocality: 'Phra Khanong Nuea, Watthana',
      addressRegion: 'Bangkok',
      postalCode: '10110',
      addressCountry: 'TH',
    },
    openingHours: 'Mo-Su 10:00-00:00',
    priceRange: 'THB 2,000 - THB 3,700',
    image: 'https://www.bunnyboymassage.com/hero-home-pc.jpg',
  };

  const activePriceData = lang === 'zh' ? priceDataZh : priceData;

  return (
    <>
      <Helmet>
        <html lang={langAttr} />
        <meta name="google-site-verification" content="oqrrPJxHE-glI4a2-kLFEyROX0bIiQgU7FxBcaITmrA" />
        <title>{t.meta.title}</title>
        <meta name="description" content={t.meta.description} />
        <meta name="keywords" content={t.meta.keywords} />
        <meta property="og:title" content={t.meta.title} />
        <meta property="og:description" content={t.meta.description} />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://www.bunnyboymassage.com/og-happy-ending.jpg" />
        <meta property="og:url" content={`https://www.bunnyboymassage.com${prefix || '/'}`} />
        <meta property="og:site_name" content="Bunny Boy Massage" />
        <meta property="og:locale" content={langAttr === 'zh-CN' ? 'zh_CN' : langAttr === 'ko' ? 'ko_KR' : 'en_US'} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={t.meta.title} />
        <meta name="twitter:description" content={t.meta.description} />
        <meta name="twitter:image" content="https://www.bunnyboymassage.com/og-happy-ending.jpg" />
        <link rel="canonical" href={`https://www.bunnyboymassage.com${prefix || '/'}`} />
        <link rel="alternate" hrefLang="en" href="https://www.bunnyboymassage.com/" />
        <link rel="alternate" hrefLang="zh" href="https://www.bunnyboymassage.com/zh" />
        <link rel="alternate" hrefLang="ko" href="https://www.bunnyboymassage.com/ko" />
        <link rel="alternate" hrefLang="x-default" href="https://www.bunnyboymassage.com/" />
        <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
        <script type="application/ld+json">{JSON.stringify(localBusinessSchema)}</script>
      </Helmet>

      <HeroSection
        title={t.hero.title}
        subtitle={t.hero.subtitle}
        tagline={t.hero.tagline}
        cta={t.hero.cta}
        imagePc="/hero-home-pc.jpg"
        imageMobile="/hero-home-mobile.jpg"
      />

      <AboutSection
        title={t.about.title}
        subtitle={t.about.subtitle}
        description={t.about.description}
        description2={t.about.description2}
        contactButton={t.cta.button}
        contactPhone={t.cta.phone}
        contactLine={t.cta.line}
        contactKakao={t.cta.kakao}
      />

      <section className="py-10 sm:py-[60px] bg-dark">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col lg:flex-row lg:gap-10 lg:items-start">
            <div className="lg:w-[35%] flex-shrink-0 mb-8 lg:mb-0">
              <video
                className="w-[95%] mx-auto lg:w-full h-auto rounded-lg gold-border"
                autoPlay
                loop
                muted
                playsInline
                preload="metadata"
              >
                <source src="/video-bunnyboy.mp4" type="video/mp4" />
              </video>
            </div>
            <div className="lg:w-[65%]">
              {(() => { const s = seoContent[0]; return (
                <div>
                  <h2 className="font-playfair text-3xl sm:text-4xl font-bold gold-gradient-text mb-6">{s.title}</h2>
                  {s.paragraphs.map((p, j) => (
                    <p key={j} className="font-montserrat text-lg sm:text-xl text-white/65 leading-relaxed mb-5">{p}</p>
                  ))}
                </div>
              ); })()}
            </div>
          </div>
        </div>
      </section>

      <section className="py-10 sm:py-[60px] bg-dark">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col-reverse lg:flex-row lg:gap-10 lg:items-start">
            <div className="lg:w-[60%]">
              {(() => { const s = seoContent[1]; return (
                <div>
                  <h2 className="font-playfair text-3xl sm:text-4xl font-bold mb-6" style={{ color: '#a77bf9' }}>{s.title}</h2>
                  {s.paragraphs.map((p, j) => (
                    <p key={j} className="font-montserrat text-lg sm:text-xl text-white/65 leading-relaxed mb-5">{p}</p>
                  ))}
                  {s.list && (
                    <ul className="space-y-3 mt-4">
                      {s.list.map((item, k) => (
                        <li key={k} className="flex items-start space-x-3">
                          <span className="mt-1" style={{ color: '#976ee2' }}>&#9670;</span>
                          <span className="font-montserrat text-lg text-white/60">{item}</span>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              ); })()}
            </div>
            <div className="lg:w-[40%] flex-shrink-0 mb-8 lg:mb-0">
              <img
                src="/content-image-1.jpg"
                alt={seoContent[1]?.imageAlt || 'Happy Ending Massage Sukhumvit'}
                className="w-[95%] mx-auto lg:w-full h-auto rounded-lg gold-border object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>

      <GallerySection
        title={labels.galleryTitle}
        subtitle={labels.gallerySubtitle}
        images={galleryImages}
      />

      <ContentSection sections={seoContent.slice(2, 4)} />

      <PriceTable
        title={labels.priceTitle}
        subtitle={labels.priceSubtitle}
        priceData={activePriceData}
      />

      <ManagerSection
        title={labels.managerTitle}
        titleColor="#b299fa"
        subtitle={labels.managerSubtitle}
        subtitleColor="#9f87e4"
        managers={managers}
      />

      <ContentSection sections={seoContent.slice(4)} />

      <ServicesSection
        title={t.services.title}
        subtitle={t.services.subtitle}
        items={t.services.items}
      />

      <WhySection title={t.why.title} items={t.why.items} />

      <FAQSection
        title={labels.faqTitle}
        subtitle={labels.faqSubtitle}
        items={faqItems}
      />

      <LocationSection
        title={labels.locationTitle}
        subtitle={labels.locationSubtitle}
        address={labels.address}
        hours={labels.hours}
        directions={labels.directions}
        mapUrl="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1937.8!2d100.5936575!3d13.7141704!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30e29fc1448bad8b%3A0x783ac84a11658233!2sBunny%20Boy%20Massage!5e0!3m2!1sen!2sth!4v1234567890"
      />

      <CTASection
        title={t.cta.title}
        subtitle={t.cta.subtitle}
        button={t.cta.button}
        phone={t.cta.phone}
        line={t.cta.line}
        kakao={t.cta.kakao}
      />
    </>
  );
}

export default HomePage;
